import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;

  h5 {
    margin-top: -15px;
    font-size: 17px;
    font-weight: 200;
  }

  h3 {
    margin-bottom: 0;
  }

  ul {
    margin: 0;
  }

  hr {
    margin: 50px 0 30px;
    opacity: 0.3;
  }
`;
